const useRolePermissionsTableColumns = apiRef => {
  const columnsData = [
    {
      field: 'display',
      headerName: 'نام نمایشی',
      flex: 1,
      minWidth: 150,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.display;
      },
    },
    {
      field: 'id',
      headerName: 'شناسه',
      flex: 1,
      minWidth: 150,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.id;
      },
    },
  ];

  return [columnsData];
};

export default useRolePermissionsTableColumns;
